(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less", "./svg-list"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"), require("./svg-list"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index, global.svgList);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index, _svgList) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _svgList = _interopRequireDefault(_svgList);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('span', {
        class: _vm.className
      });
    },
    name: 'nx-inline-loading',
    mounted: function mounted() {
      var _this = this;

      this.$nextTick(function () {
        _this.$el.innerHTML = _svgList.default[_this.type] || '';
      });
    },
    props: {
      type: {
        type: String,
        default: 'roller' // 'roller', 'bubbles', 'spiral', 'spinner', 'gray-roller-image'

      }
    },
    computed: {
      className: function className() {
        var ret = {};
        ret["nx-inline-loading-".concat(this.type)] = true; // 判断节点渲染成image还是svg

        if (this.type && this.type.indexOf('-image') > -1) {
          ret['nx-inline-loading-image'] = true;
        } else {
          ret['nx-inline-loading'] = true;
        }

        return ret;
      }
    }
  };
  _exports.default = _default;
});